import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {ColumnNodeProvider} from "../PA.UIM.Core/SearchTreeUtils";

const vUI_Simulation_Search_Fields: {[id: string]: ISearchProviderField}  = {
    WB_SIMULATION_ID:    {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'WB Simulation Id',     columnResourceName: 'colId',             alignment: HorizAlignment.Left},  domainOptions: {} },
    SIMULATION_ID:       {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Simulation Id',        columnResourceName: 'colSimulationId',             alignment: HorizAlignment.Left},  domainOptions: {maxLength: 150}},
    SIMULATION_NAME:     {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Simulation Name',      columnResourceName: 'colSimulationName',      alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    CUSTOMER_NAME:     {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Customer',      columnResourceName: 'colCustomerName',      alignment: HorizAlignment.Left},  domainOptions: {maxLength: 150}},
    START_DT:            {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Start Date', columnResourceName: 'colStart', dateFormat:'MM/dd/yyyy' , alignment: HorizAlignment.Center}, domainOptions: {}},
    END_DT:              {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'End Date', columnResourceName: 'colEnd', dateFormat:'MM/dd/yyyy' , alignment: HorizAlignment.Center}, domainOptions: {}},
    LAST_CALC_DTTS:      {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Last Solved Date', columnResourceName: 'colCalc' , dateFormat:'MM/dd/yyyy', alignment: HorizAlignment.Center}, domainOptions: {}},
    CREATED_DTTS:      {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Created Date', columnResourceName: 'colCreatedDt' , dateFormat:'MM/dd/yyyy', alignment: HorizAlignment.Center}, domainOptions: {}},
    MODIFIED_DTTS:      {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Last Modified Date', columnResourceName: 'colModify' , dateFormat:'MM/dd/yyyy', alignment: HorizAlignment.Center}, domainOptions: {}},
    AUTHUSR_EMAIL:          {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Created By',     columnResourceName: 'colCreatedBy',             alignment: HorizAlignment.Left},  domainOptions: {} },
    TREE_PATH:           {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Tree Path',      columnResourceName: 'colPlnCst',   alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256}},
    WB_PRDH_ID:          {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'WB PrdH Id',     columnResourceName: 'colWBPrdHId',             alignment: HorizAlignment.Left},  domainOptions: {} },

};

const SimulationInputSearchProviderBasic: ISearchProvider = {

    keyFields: {id: 'WB_SIMULATION_ID',
        id_ui: 'SIMULATION_ID',
        name:  'SIMULATION_NAME'

    },

    searchProviderFields: vUI_Simulation_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Simulation_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[])=> {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                });
        })
    }
};

const SimulationSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5SourceId: "SimulationSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'SIMULATION_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'SIMULATION_NAME', renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'SIMULATION_ID', 'SIMULATION_NAME','AUTHUSR_EMAIL','CUSTOMER_NAME','CREATED_DTTS','LAST_CALC_DTTS','MODIFIED_DTTS','START_DT','END_DT',
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: SimulationInputSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};



const SimulationComparisonSearchProvider: ISearchProvider = {

    keyFields: {id: 'WB_SIMULATION_ID',
        id_ui: 'SIMULATION_ID',
        name:  'SIMULATION_NAME'

    },

    searchProviderFields: vUI_Simulation_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Simulation_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[])=> {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                });
        })
    }
};

const SimulationComparisonSearchProfile: ISearchProfile = {
    profileId: "SimulationComparisonSearchProfile",
    profileName: "Simulation Comparison",
    renderOptions: {ui5SourceId: "SimulationComparisonSearchProfile"},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'SIMULATION_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'SIMULATION_NAME', renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'SIMULATION_ID', 'SIMULATION_NAME','START_DT','END_DT'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: SimulationComparisonSearchProvider,

    profileTreeIdDefault: "ByDirectoryPath",
    profileTrees: [
        {treeId: "ByDirectoryPath",
            treeName: "By Hierarchy",
            nodeProviders: [new ColumnNodeProvider(['TREE_PATH'], {defaultValues: "Tree Path not set", levelDelimiter: "/", ruggedTree: true})],
            renderOptions: {ui5: {leafIcon: "sap-icon://Chart-Tree-Map"}}}
    ],

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const SimulationSearch: ISearch = {
    searchName: "Find Simulation",
    renderOptions: {ui5ResourceId: "SimulationSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [SimulationSearchProfileByName]
};

const SimulationComparisonSearch: ISearch = {
    searchName: "Find Promotions",
    renderOptions: {ui5ResourceId: "SimulationSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [SimulationComparisonSearchProfile]
};
PAEnvironment.registerBusinessObjectSearch("SimulationBO", "Simulation", SimulationSearch, "Simulation Search")

export {SimulationSearch, SimulationComparisonSearch}

